// Updated ReadingAttempts.js
import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { getUserReadingAttempts } from "../api/index";

const ReadingAttempts = () => {
    const dispatch = useDispatch();
    const reduxUser = useSelector((state) => state.auth?.authData);

    // Normalize user data (always return the user object with _id)
    const getStoredUser = () => {
        if (reduxUser?.result) return reduxUser.result; // Redux stores { result, token }
        const localUser = JSON.parse(localStorage.getItem("user_info"));
        if (localUser?.result) return localUser.result; // localStorage may store same structure
        return null;
    };

    const [currentUser, setCurrentUser] = useState(getStoredUser);
    const [attempts, setAttempts] = useState([]);
    const [loading, setLoading] = useState(true);

    // Sync Redux with localStorage if not in Redux
    useEffect(() => {
        const storedUser = getStoredUser();
        setCurrentUser(storedUser);

        if (!reduxUser && storedUser) {
            dispatch({ type: "AUTH", data: storedUser });
        }
    }, [reduxUser, dispatch]);

    const userId = currentUser?._id;

    useEffect(() => {
        if (!userId) {
            console.error("⚠️ No userId found, fetch skipped");
            setLoading(false);
            return;
        }

        console.log("Fetching reading attempts for userId:", userId);
        setLoading(true);

        getUserReadingAttempts(userId)
            .then((res) => {
                console.log("Attempts received:", res.data);
                setAttempts(res.data.attempts || []);
                setLoading(false);
            })
            .catch((err) => {
                console.error("Failed to fetch reading attempts:", err);
                setAttempts([]);
                setLoading(false);
            });
    }, [userId]);

    if (loading) return <p>Loading reading attempts...</p>;
    if (!attempts.length) return <p>No reading test attempts found.</p>;

    return (
        <div>
            <h2>Your Reading Test Attempts</h2>
            <table>
                <thead>
                    <tr>
                        <th>Test Number</th>
                        <th>Date</th>
                        <th>Score</th>
                        <th>CLB</th>
                    </tr>
                </thead>
                <tbody>
                    {attempts.map((a, index) => (
                        <tr key={a._id || index}>
                            <td>{a.testNumber ?? "-"}</td>
                            <td>
                                {a.attemptDate
                                    ? new Date(a.attemptDate).toLocaleDateString()
                                    : "-"}
                            </td>
                            <td>{a.attemptScore ?? "-"}</td>
                            <td>{a.clbScore ?? "-"}</td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
};

export default ReadingAttempts;


